const faqItems = [
  {
    q: '密桃视频是否需要注册才能观看？',
    a: '不需要。密桃视频所有影片均为免费在线观看，无需注册或登录，打开网站即可直接播放。我们致力于提供零门槛的观影体验，让每位用户都能轻松享受高清影视内容。',
  },
  {
    q: '91视频和91视频网站的资源更新频率是怎样的？',
    a: '91视频、91视频网站以及久久视频等专区每日更新最新资源。新片上线后24小时内完成同步，热门剧集与院线大片优先上线。您可以在"最新动态"板块查看每日更新记录。',
  },
  {
    q: '播放卡顿或加载缓慢怎么办？',
    a: '91在线视频播放器采用多线路自适应切换技术，如遇卡顿可尝试切换清晰度或刷新页面。推荐使用Chrome、Edge等现代浏览器，并确保网络连接稳定。平台已针对移动端进行全面优化，手机观看同样流畅。',
  },
  {
    q: '密桃视频支持哪些设备观看？',
    a: '密桃视频支持PC、平板、手机等全设备访问。网页端无需安装任何插件，移动端浏览器直接访问即可获得适配后的观影界面。91在线视频播放器针对不同屏幕尺寸做了响应式优化，大屏小屏都能畅快观影。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2 justify-center">
          <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
            <i className="ri-question-answer-line text-secondary-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">常见问题</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 text-center">快速了解密桃视频的常见疑问</p>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div key={i} className="rounded-xl bg-background-50 border border-background-200/60 p-4 md:p-5">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 shrink-0">Q{i + 1}.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}